import React, { Component } from "react";
import { Link } from "react-router-dom";
import expertises from "../../../data/expertise/expertise.json";

class ExpertiseHomeBlock extends Component {
  render() {
    return (
      <div className="bannerContainer">
        <div className="sigma_service-wrapper style-18 margin-negative">
          <div className="section-title flex-title">
            <h3 className="title mb-0" style={{ fontSize: "48px" }}>
              Transformative Therapies
            </h3>
            <Link to="/expertise" className="sigma_btn mt-3 mt-sm-0">
              Explore
              <i className="fal fa-arrow-right ml-3" />
            </Link>
          </div>
          <div className="row">
            {/* Data */}
            {expertises.map((item, i) => (
              <div className="col-lg-3 col-md-6 px-1" key={i}>
                <div className="sigma_service style-18">
                  <div className="sigma_service-thumb">
                    <img
                      src={process.env.PUBLIC_URL + item.logoPath}
                      style={{
                        width: "30px",
                        height: "30px",
                      }}
                      alt=""
                    />
                  </div>
                  <div className="sigma_service-body">
                    <h5>
                      <Link
                        style={{
                          color: "#7aa836",
                          fontWeight: "700",
                          fontSize: "24px",
                        }}
                        to={"/expertise/" + item.id}
                      >
                        {item.title}
                      </Link>
                    </h5>
                    <p
                      className="lineClamp"
                      style={{
                        WebkitLineClamp: 4,
                      }}
                    >
                      {item.shorttext}
                    </p>
                  </div>
                </div>
              </div>
            ))}
            {/* Data */}
          </div>
        </div>
      </div>
    );
  }
}

export default ExpertiseHomeBlock;
